/**
 * Voorraad Service - API calls voor hiërarchisch voorraad beheer
 */

import apiFetch from './api';

export interface VoorraadCategorie {
  id: number;
  naam: string;
  volgorde: number;
  actief: boolean;
}

export interface VoorraadGroep {
  id: number;
  parent_id: number | null;
  categorie_id: number;
  naam: string;
  niveau: number;
  volgorde: number;
  actief: boolean;
  children_count?: number;
  items_count?: number;
}

export interface VoorraadItem {
  id: number;
  groep_id: number;
  onderdeel_type: string;
  artikelnummer: string;
  omschrijving: string | null;
  fabrikant: string | null;
  model: string | null;
  leverancier: string | null;
  specificatie_1: string | null;
  specificatie_2: string | null;
  specificatie_3: string | null;
  aantal_voorraad: number;
  min_voorraad: number | null;
  inkoopprijs: number | null;
  verkoopprijs: number | null;
  prijs_per_verpakking: number | null;
  verpakkingseenheid: number | null;
  actief: boolean;
}

export const voorraadService = {
  // Categorieën
  async getCategorieen(): Promise<VoorraadCategorie[]> {
    return apiFetch('/api/v1/voorraad/categorieen');
  },

  // Groepen
  async getGroepen(categorieId: number, parentId?: number): Promise<VoorraadGroep[]> {
    const params = new URLSearchParams();
    params.append('categorie_id', categorieId.toString());
    if (parentId !== undefined) {
      params.append('parent_id', parentId.toString());
    }
    return apiFetch(`/api/v1/voorraad/groepen?${params.toString()}`);
  },

  async getGroepById(id: number): Promise<VoorraadGroep> {
    return apiFetch(`/api/v1/voorraad/groepen/${id}`);
  },

  // Items
  async getItems(groepId: number): Promise<VoorraadItem[]> {
    return apiFetch(`/api/v1/voorraad/items?groep_id=${groepId}`);
  },

  async getItemById(id: number): Promise<VoorraadItem> {
    return apiFetch(`/api/v1/voorraad/items/${id}`);
  },

  async searchItems(): Promise<VoorraadItem[]> {
    return apiFetch(`/api/v1/voorraad/items/all`);
  },
};
